<template>
  <div class="blind-box-out-of-stock">
    <HomeHeader />
    <img :src="signImage" alt="Sorry, we're Out of Stock!" />
  </div>
</template>

<script>
const Config = require('~/config/default.env').default;
const MINUTE = 60;
const SECOND = 1000;
export default {
  components: {
    HomeHeader: () => import('./layout/header.vue'),
  },
  data() {
    return {
      signImage: '/static/img/blind-box/out-of-stock/sign-new.svg',
      intervalId: null,
      stockCheckInterval: 5 * MINUTE * SECOND,
      storeDetail: null,
    };
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  },
  mounted() {
    const cookieStoreDetail = Cookies.get('store_detail');
    if (!cookieStoreDetail || cookieStoreDetail === '') {
      this.$router.replace('/');
    }
    this.storeDetail = JSON.parse(cookieStoreDetail);
    this.intervalId = setInterval(() => {
      this.checkOutOfStock();
    }, this.stockCheckInterval);
  },
  methods: {
    checkOutOfStock() {
      const checkStockUrl = `${Config.MS_CATALOG_API_URL}/vending-machines/${this.storeDetail._id}`;
      this.$axios.get(checkStockUrl).then((response) => {
        if (response && response.data && response.data.data) {
          const productList = response.data.data.products;
          const availableProduct = productList.filter((prod) => prod.quantity > 0).length;
          if (availableProduct > 0) {
            this.$router.push('/blind-box');
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import './font/font.scss';
$bg-gradient: linear-gradient(180deg, #327fff 0%, #b0ceff 100%);
$footer-image-background: url('/static/img/blind-box/global/footer-v2.webp') no-repeat bottom center;
$footer-size: 100% auto;

$pole-image-background: url('/static/img/blind-box/global/pole.png') no-repeat bottom center;
$pole-size: 40px 90vh;

.blind-box-out-of-stock {
  background: $footer-image-background, $pole-image-background, $bg-gradient;
  background-size: $footer-size, $pole-size;
  height: 100vh;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
